import ContractRequestList from './List';
import ContractRequestEdit from './Edit';

const ContractRequestLabel = "Contract (PIF) List";

export { ContractRequestList, ContractRequestEdit, ContractRequestLabel };
